import { useEffect } from 'react';

import usePreviewFeature from '../../hooks/usePreviewFeature';
import '../../scss/v2/v2-base.scss';
import '../../scss/v2/v2-pages.scss';

const PreviewBodyClass = () => {
  const isV2 = usePreviewFeature('cabinet-v2');

  useEffect(() => {
    document.body.classList.toggle('nb-v2', isV2);

    return () => document.body.classList.remove('nb-v2');
  }, [isV2]);

  return null;
};

export default PreviewBodyClass;
